import { useMemo } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'
import { getThemeClassName } from 'lib/theme/themeUtils'
import TextButton from 'LuxKit/Button/TextButton'
import { CRUISE_ROUTES, CRUISE_TOP_OFFER_FIXED_POSITION_IDS, CRUISE_BANK_UNIFIED_FILTERS } from 'constants/cruise'
import useOfferList from 'hooks/Offers/useOfferList'
import { insertFixedPositionCruiseOfferIds } from 'lib/cruises/insertFixedPositionCruiseOfferIds'

function CruisePageTopOffersCarousel() {
  const intl = useIntl()
  const rawOfferList = useOfferList(CRUISE_BANK_UNIFIED_FILTERS)

  const offerList = useMemo((): App.OfferList => ({
    ...rawOfferList,
    offerIds: insertFixedPositionCruiseOfferIds(rawOfferList.offerIds, CRUISE_TOP_OFFER_FIXED_POSITION_IDS),
  }), [rawOfferList])

  const viewMoreLabel = intl.formatMessage({
    id: '5nqFJM6RzdBgBbhPiQln',
    defaultMessage: 'View More',
    description: 'Button text to view more top cruise offers in the cruise section',
  })

  if (!offerList.fetching && !offerList.offerIds.length) return null

  return <Group gap={32} direction="vertical">
    <LayoutContainer>
      <Group gap={16} direction="horizontal" horizontalAlign="space-between">
        <Heading variant="heading2">
          <FormattedMessage
            id="rG6K-EkHT_xjnE-l5kNq"
            defaultMessage="Today’s top <i>cruise</i> offers"
            description="Section heading for top cruise offers carousel in the cruises section"
            values={{ i: (chunks) => <i>{chunks}</i> }}
          />
        </Heading>
        <TextButton kind="tertiary" to={`${CRUISE_ROUTES.SEARCH_PAGE}`}>{viewMoreLabel}</TextButton>
      </Group>
    </LayoutContainer>

    <OfferListCarousel
      tileStyle="card-default"
      tileSize="medium"
      overrideOfferList={offerList}
      className={getThemeClassName({ desktop: 'default' })}
    />
  </Group>
}

export default CruisePageTopOffersCarousel
